import { getTeamUrl } from 'Common'

export default () => (dispatch, getState) => {

  const { id } = getState().screens.InvoiceView.invoice

  window.open(getTeamUrl(`invoices/${id}/pdf`, 'exports'))

}